
import { mapState } from "vuex";
import { gtmMap } from "@/util/gtm";

export default {
	data() {
		return {
			which: ""
		};
	},
	created() {
		this.which = this.$route.path.match(/^\/(?<which>(?:starter|streaming|creator|h1-mini)-pc(?:-plus)?)/i).groups.which;

		if (this.which.includes("starter-pc") && this.$route.query.f == "n") {
			localStorage.setItem("init-start-cart", 1);
			localStorage.setItem("starter-pc-index", this.which == "starter-pc" ? 0 : 1);
			this.$router.replace({ query: {} });
		}
	},
	computed: {
		...mapState({
			builds: state => state.StarterPc.builds,
			buildsIndex: state => state.StarterPc.buildsIndex,
			cart: state => state.StarterPc.cart
		}),
		gtmPrebuildVariables() {
			const gtmEcommmercePrebuild = gtmMap.starterSeriesPrebuildToProduct(this.builds[this.buildsIndex], this.cart.case);
			const gtmPrebuildVariables = {
				pcSKU: gtmEcommmercePrebuild.id,
				pcName: gtmEcommmercePrebuild.name,
				pcPrice: gtmEcommmercePrebuild.price,
				pcColor: gtmEcommmercePrebuild.variant
			};
			return gtmPrebuildVariables;
		}
	}
};
